import { render } from "./Home.vue?vue&type=template&id=5283eb7f&scoped=true"
const script = {}

import "./Home.vue?vue&type=style&index=0&id=5283eb7f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5283eb7f"]])

export default __exports__